'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import useEmblaCarousel from 'embla-carousel-react';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { BREAKPOINTS } from '@/constants';
import { useSelectedSnapIndex } from '@/hooks/useSelectedSnapIndex';
interface DesktopMainBannerSectionProps {
  bannerItems: {
    href: string;
    title: string;
    imageUrl: string;
    target?: string;
  }[];
  className?: string;
}
export const DesktopMainBannerSection = t0 => {
  const $ = _c(37);
  const {
    bannerItems,
    className
  } = t0;
  const isLooping = bannerItems.length > 1;
  let t1;
  if ($[0] !== isLooping) {
    t1 = {
      loop: isLooping,
      align: "center",
      containScroll: false
    };
    $[0] = isLooping;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t1);
  const activeIndex = useSelectedSnapIndex(emblaApi);
  let t2;
  bb0: {
    if (bannerItems.length <= 1 || bannerItems.length > MIN_BANNER_LENGTH) {
      t2 = bannerItems;
      break bb0;
    }
    const targetLength = MIN_BANNER_LENGTH * 2;
    let t3;
    if ($[2] !== bannerItems) {
      t3 = Array.from({
        length: targetLength
      }, (_, index) => bannerItems[index % bannerItems.length]);
      $[2] = bannerItems;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    t2 = t3;
  }
  const list = t2;
  const totalUniqueItems = bannerItems.length;
  const paginationIndex = activeIndex % bannerItems.length;
  let t3;
  if ($[4] !== activeIndex || $[5] !== paginationIndex || $[6] !== totalUniqueItems) {
    let t4;
    if ($[8] !== activeIndex || $[9] !== paginationIndex) {
      t4 = (__0, uniqueIndex) => paginationIndex === uniqueIndex ? activeIndex : uniqueIndex;
      $[8] = activeIndex;
      $[9] = paginationIndex;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t3 = new Set(Array.from({
      length: totalUniqueItems
    }, t4));
    $[4] = activeIndex;
    $[5] = paginationIndex;
    $[6] = totalUniqueItems;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const exposedIndexes = t3;
  if (bannerItems.length < 1) {
    return null;
  }
  let t4;
  if ($[11] !== className) {
    t4 = cn("w-fit max-w-full [--banner-gap:12px] [--banner-h:180px] [--banner-w:502px]", "mobile:[--banner-h:calc(var(--banner-w)*120/335)] mobile:[--banner-w:calc(100vw_-_40px)] tablet:[--banner-h:120px] tablet:[--banner-w:335px] mobile-tablet:w-full", className);
    $[11] = className;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== isLooping || $[14] !== paginationIndex || $[15] !== totalUniqueItems) {
    t5 = isLooping && <div className="pointer-events-none absolute z-10 hidden mobile-tablet:block" style={{
      bottom: "var(--banner-gap)",
      right: "calc((100% - var(--banner-w)) / 2 + var(--banner-gap))"
    }}><div className="h-20 w-36 whitespace-nowrap rounded-pill bg-Gray-black font-600 text-Gray-white flex-center typo-caption2">{`${paginationIndex + 1} / ${totalUniqueItems}`}</div></div>;
    $[13] = isLooping;
    $[14] = paginationIndex;
    $[15] = totalUniqueItems;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      width: `calc((var(--banner-w) + var(--banner-gap)) * ${MIN_BANNER_LENGTH} - var(--banner-gap))`
    };
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      transform: "translate3d(calc(50% - var(--banner-w) / 2), 0px, 0px)"
    };
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== activeIndex || $[20] !== exposedIndexes || $[21] !== list) {
    let t9;
    if ($[23] !== activeIndex || $[24] !== exposedIndexes) {
      t9 = (t10, index_0) => {
        const {
          href,
          imageUrl,
          title,
          target
        } = t10;
        return <div key={`${href}-${index_0}`} className="mr-[var(--banner-gap)] w-[var(--banner-w)] min-w-0 flex-[0_0_auto]"><CustomLink href={href} target={target} aria-label={`${title} 상세페이지로 이동`} aria-hidden={exposedIndexes.has(index_0) ? undefined : true} tabIndex={exposedIndexes.has(index_0) ? undefined : -1} className={cn("rounded-large transition-opacity duration-200 ease-out", "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-B-500", "active:opacity-80", "hover:opacity-80", "mobile-tablet:w-full")}><div className={cn("relative overflow-hidden rounded-large", "h-[var(--banner-h)] w-[var(--banner-w)]", "transition-opacity duration-300", activeIndex === index_0 ? "opacity-100" : "mobile-tablet:opacity-50")}><Image src={imageUrl} fill={true} sizes={`${BREAKPOINTS.MOBILE} calc(100vw - 40px), ${BREAKPOINTS.TABLET} 335px, 502px`} alt={`${title}에 관한 배너 이미지`} className="rounded-large object-cover" preload={index_0 < MIN_BANNER_LENGTH} fetchPriority={index_0 === 0 ? "high" : undefined} /></div></CustomLink></div>;
      };
      $[23] = activeIndex;
      $[24] = exposedIndexes;
      $[25] = t9;
    } else {
      t9 = $[25];
    }
    t8 = list.map(t9);
    $[19] = activeIndex;
    $[20] = exposedIndexes;
    $[21] = list;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[26] !== t8) {
    t9 = <div className="flex" style={t7}>{t8}</div>;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== emblaRef || $[29] !== t9) {
    t10 = <div ref={emblaRef} className="max-w-full overflow-hidden" style={t6}>{t9}</div>;
    $[28] = emblaRef;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t10 || $[32] !== t5) {
    t11 = <div className="relative">{t5}{t10}</div>;
    $[31] = t10;
    $[32] = t5;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t11 || $[35] !== t4) {
    t12 = <section className={t4}>{t11}</section>;
    $[34] = t11;
    $[35] = t4;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  return t12;
};
const MIN_BANNER_LENGTH = 5;